import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Workarea from "./Workarea";
import { getGame } from "../redux/asyncThunk/userActions";
import CircularProgress from "@mui/material/CircularProgress";
import { userSlice } from "../redux/user/userSlice";
import { firstSceneNodes } from "./nodes/FirstSceneNode";

const { addNode } = userSlice;

export default function Game() {
  const [gameData, setGameData] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const selectedGameId = useSelector((state) => state.user?.selectedGameId);
  const status = useSelector((state) => state.user?.status);
  const game = useSelector((state) => state.user.game);

  useEffect(() => {
    if (selectedGameId) {
      setGameData(null);
      dispatch(getGame({ gameId: selectedGameId }));
    } else {
      navigate("/main", { replace: true });
    }
  }, [dispatch, navigate, selectedGameId]);

  useEffect(() => {
    if (!game || game._id !== selectedGameId) return;

    if ((game.nodes?.length ?? 0) < 1) {
      dispatch(addNode({ data: [...firstSceneNodes] }));
    } else {
      setGameData(game);
    }
  }, [dispatch, game, selectedGameId]);

  const isInitialLoading = status === "loading" && !gameData;

  return (
    <div className="app-editor">
      <header className="app-editor__header">
        <h1 className="app-editor__title">
          {gameData?.title || "Загрузка проекта…"}
        </h1>
      </header>

      {isInitialLoading ? (
        <div className="app-loading">
          <CircularProgress />
        </div>
      ) : gameData ? (
        <Workarea game={gameData} />
      ) : null}
    </div>
  );
}
